import React, { createContext, useContext } from "react";

import { useDispatch, useSelector } from "react-redux";
import { loadingState, setScreenSizeType } from "../redux/reducers/loadingReducer";

// Create Context
const LoadingContext = createContext();

// Toast Provider Component
export const LoadingProvider = ({ children }) => {
     const dispatch = useDispatch();
     const loadingReduxState = useSelector(loadingState);

     React.useEffect(() => {
          function getScreenSize() {
               const width = window.innerWidth;

               if (width < 640) {
                    return 'xs';
               } else if (width >= 640 && width < 768) {
                    return 'sm';
               } else if (width >= 768 && width < 1024) {
                    return 'md';
               } else if (width >= 1024 && width < 1280) {
                    return 'lg';
               } else if (width >= 1280 && width < 1536) {
                    return 'xl';
               } else {
                    return '2xl';
               }
          }
          function checkBreakpoint() {
               if (window.matchMedia("(max-width: 639px)").matches) {
                    return 'xs';
               } else if (window.matchMedia("(min-width: 640px) and (max-width: 767px)").matches) {
                    return 'sm';
               } else if (window.matchMedia("(min-width: 768px) and (max-width: 1023px)").matches) {
                    return 'md';
               } else if (window.matchMedia("(min-width: 1024px) and (max-width: 1279px)").matches) {
                    return 'lg';
               } else if (window.matchMedia("(min-width: 1280px) and (max-width: 1535px)").matches) {
                    return 'xl';
               } else {
                    return '2xl';
               }
          }

          // Event listener to update screen size on resize
          window.addEventListener('load', () => dispatch(setScreenSizeType(getScreenSize())));
          window.addEventListener('resize', () => dispatch(setScreenSizeType(getScreenSize())));

          // Cleanup function to remove event listener
          return () => { };
     }, []);

     return (
          <LoadingContext.Provider value={{}}>
               {children}
               {loadingReduxState.globalLoading !== undefined && loadingReduxState.globalLoading === true
                    && (<div className="fixed top-0 left-0 w-full h-full bg-gray-800/50 backdrop-blur-lg z-50 flex items-center justify-center">
                         <div className="animate-spin rounded-full h-12 w-12 border-8 border-t-transparent border-gray-100"></div>
                    </div>)}
          </LoadingContext.Provider>
     );
};

// Custom Hook to use Toast
export const useToast = () => {
     return useContext(LoadingContext);
};
